import { HorizonInterval } from './Horizon';

export default class ReportHorizonSequencingXRef {
    constructor(id: number, sequence: number) {
        this.horizonIntervalId = id;
        this.sequencePosition = sequence;
    }

    id: number;
    horizonIntervalId?: number;
    reportHorizonSequencingId?: number;
    sequencePosition?: number;
    fieldLookupId?: number;
    sectionId?: number;

    // Not mapped
    horizonInterval: HorizonInterval;
}


// WEBPACK FOOTER //
// ./src/models/ReportHorizonSequencingXRef.ts